import { secureGet, securePost, securePut } from '../utils/HttpUtils';

const apiUrls = {
  clients: '/v1/private/clients/',
};

export const saveBalanceItems = async (
  cuit: string,
  applicationId: string,
  balance_sheet: any
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    applicationId +
    '/balance-sheets';
  return securePost(url, balance_sheet);
};

export const updateBalanceItems = async (
  cuit: string,
  applicationId: string,
  balanceSheetId: number,
  balance_sheet: any
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    applicationId +
    '/balance-sheets/' +
    balanceSheetId;
  return securePut(url, balance_sheet);
};

export const getBalanceInfoByCode = async (
  cuit: string,
  balanceSheetCode: string
) => {
  const url = apiUrls.clients + cuit + '/balance-sheets/' + balanceSheetCode;
  return secureGet(url);
};

export const getBalanceSheetsByCuit = async (cuit: string) => {
  const url = apiUrls.clients + cuit + '/balance-sheets';
  return secureGet(url);
};

export const postRiskData = async (cuit: string, id: string, body: any) => {
  const url =
    apiUrls.clients + cuit + '/applications/' + id + '/risk_analysis ';
  return securePost(url, body);
};

export const putRiskData = async (cuit: string, id: string, body: any, riskAnalysisId: number) => {
  const url =
    apiUrls.clients + cuit + '/applications/' + id + '/risk_analysis/' + riskAnalysisId;
  return securePut(url, body);
};

export const getPostBalanceItems = async (
  cuit: string,
  id: string,
  yearTo: string,
  MonthTo: string
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    id +
    '/purchases-sales?' +
    'yearTo=' +
    yearTo +
    '&monthTo=' +
    MonthTo;
  return secureGet(url);
};

export const updatePostBalanceItems = async (
  cuit: string,
  application: any,
  id: string
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    id +
    '/post-balance-sheet-items';
  return securePut(url, application);
};

export const getDebts = async (cuit: string, code: string) => {
  const url = apiUrls.clients + cuit + '/debts/' + code;
  return secureGet(url);
};

export const saveDebts = async (cuit: string, applicationId: string) => {
  const url =
    apiUrls.clients + cuit + '/applications/' + applicationId + '/debts';
  return securePost(url, {});
};

export const updateDebts = async (
  cuit: string,
  applicationId: string,
  debtId: string,
  codes: string[]
) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    applicationId +
    '/debts/' +
    debtId;
  return securePut(url, codes);
};
